import { createLogger } from "@/logger";

const log = createLogger("query");

// biome-ignore lint/suspicious/noExplicitAny: Query and Arguments are dynamic
export function logQuery(name: string, query: any, ...args: any[]) {
  const s = query.toSQL();
  const sq = s.sql;
  const params = s.params;
  const emptyParams = params.filter((p: unknown) => p === undefined || p === null || p === "").length > 0;
  if (emptyParams) {
    log.error("Empty Params", { name, params, sq }, ...args);
  }
  log.debug("Query", { name, params, sq }, ...args);
}
